import React from "react";
import { Tooltip, OverlayTrigger, Badge } from "react-bootstrap";
import "./VideoThumbnailCard.css";
import { connect } from "react-redux";
import { fetchVideo } from "../../actions/videoActions";
import { openSignUpModal } from "../../actions/generalActions";
import { getCategoryColour } from "../../utils";

class VideoThumbnailCard extends React.Component {
  state = {
    isvideoCardHover: false,
    backgroundColor: "rgba(0,0,0,0)",
    subscribeModalShow: false,
  };

  handleVideoPlayIfLoggedIn = async (isFreeVideo, videoId, playOrder) => {
    if (!this.props.userStatus?.isLoggedIn) {
      this.props.openSignUpModal();
    } else {
      // user is logged in
      if (this.props.userStatus?.isPremium) {
        // user is premium so play the video
        const videoLink = await this.props.fetchVideo(videoId);
        if (!this.props.error)
          this.props.handleVideoThumbnailClick(videoLink, playOrder, videoId);
      } else if (!isFreeVideo && !this.props.userStatus?.isPremium) {
        // user not premium and video is not free video ask to buy membership
        this.props.handleShowSubscribeModal();
      } else if (isFreeVideo && !this.props.userStatus?.isPremium) {
        // user not premium but video is free so play the video
        // alert("not premium but watch this free video");
        const videoLink = await this.props.fetchVideo(videoId);

        if (!this.props.error) {
          this.props.handleVideoThumbnailClick(videoLink, playOrder, videoId);
        }
      }
    }
  };

  setIsVideoCardHover = (val) => {
    this.setState({ isvideoCardHover: val });
  };

  render() {
    const lockStyles = this.props.video.isFreeVideo
      ? {
          width: "4.7rem",
          borderRadius: "10px",
          fontSize: "0.8rem",
          background: "rgba(0, 0, 0, 0.7)",
          color: "#FFF",
        }
      : {
          width: "1.5rem",
          borderRadius: "25%",
          fontSize: "0.9rem",
          background: "rgba(0, 0, 0, 0.7)",
          color: "#FFA500",
        };

    return (
      <div className="card-container-custom">
        <div
          className={this.props.isSpecial ? "videos-card-container-special" : "videos-card-container"}
          onMouseEnter={() => this.setIsVideoCardHover(true)}
          onMouseLeave={() => this.setIsVideoCardHover(false)}
          onClick={() =>
            this.handleVideoPlayIfLoggedIn(
              this.props.video.isFreeVideo,
              this.props.video._id,
              this.props.video.playOrder
            )
          }
        >
          <img
            className="videos-card-img"
            src={this.props.video.thumbnailLink}
            alt={`thumbnail for ${this.props.video.title}`}
            onLoad={this.props.imgOnLoad}
            width="1200"
            height="700"
          />
          {!this.props.isSpecial && <Badge
            className="videos-card-badge"
            style={{ background: getCategoryColour(this.props.video.category) }}
          >
            {this.props.video.category}
          </Badge>}
          {(!this.props.userStatus?.isLoggedIn ||
            (!this.props.userStatus?.isPremium &&
              !this.props.video.isFreeVideo)) && (
            <div className="videos-card-lock-icon" style={lockStyles}>
              {!this.props.video.isFreeVideo && <i className="fa fa-star"></i>}
              {this.props.video.isFreeVideo && <div>Free video</div>}
            </div>
          )}
          {/* <Fade duration={400} when={this.state.isvideoCardHover} bottom> */}
          <div className={this.props.isSpecial ?" videos-card-overlay-special" : "videos-card-overlay"}>
            <OverlayTrigger
              placement="bottom"
              delay={{ show: 250, hide: 400 }}
              overlay={(props, title = this.props.video.title) => (
                <Tooltip id="button-tooltip" {...props}>
                  {title}
                </Tooltip>
              )}
            >
              <div className="video-card-overlay-content">
                <div className="video-card-play-button-container">
                  <i className="fas fa-play-circle"></i>
                </div>
                <div className="videos-card-overlay-text">
                  <div className="videos-card-overlay-text-heading">
                    {this.props.video.title}
                  </div>
                </div>
              </div>
            </OverlayTrigger>
          </div>
          {/* </Fade> */}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    videoLink: state.videos.videoLink,
    error: state.videos?.error,
    userStatus: state.userLoggedinAndPremiumCheck,
  };
};

export default connect(mapStateToProps, { fetchVideo, openSignUpModal })(
  VideoThumbnailCard
);
